import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/account-user-icon.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-78d7d562"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "my-account-page" }
const _hoisted_2 = { class: "account-container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "my-account-page-header" }, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "user icon illustration",
    src: _imports_0
  }),
  /*#__PURE__*/_createElementVNode("h1", null, "My account")
], -1))
const _hoisted_4 = {
  key: 0,
  style: {"margin-bottom":"2rem"}
}
const _hoisted_5 = {
  key: 0,
  class: "btn-container"
}
const _hoisted_6 = { key: 2 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "my-account-page-header" }, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "membership icon illustration",
    src: _imports_0
  }),
  /*#__PURE__*/_createElementVNode("h1", null, "My profile")
], -1))

import { computed, ref } from "vue";
import { csContext } from "../../services/cs-context";
import { MyAccountDetailsApiModel } from "../../api-models";
import EditableUserDetails from "../../components/my-account/editable-user-details.vue";
import ChangePassword from "../../components/my-account/change-password.vue";
import SuccessMessage from "../../components/my-account/success-message.vue";
import MyProfileSettings from "../../components/my-account/my-profile-settings.vue";

type SuccessfulDetailUpdate = {
  isDetailsUpdated: boolean;
  detailChanged: string;
  updatedDetails?: MyAccountDetailsApiModel;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'my-account',
  setup(__props) {

const isChangingPassword = ref(false);

const successfulDetailChange = ref(false);

const detailsChanged = ref("details");

const updatedDetails = ref<MyAccountDetailsApiModel | null>(null);

const editableDetails = computed<MyAccountDetailsApiModel>(() => {
  const userDetails = {
    firstName: csContext.user.firstName,
    lastName: csContext.user.lastName,
    email: csContext.user.email,
  };
  return updatedDetails.value ?? userDetails;
});

const userId = computed<string>(() => {
  return csContext.user.id;
});

const toggleChangePassword = (): void => {
  isChangingPassword.value = !isChangingPassword.value;
};

const toggleSuccessMessage = (details: SuccessfulDetailUpdate): void => {
  successfulDetailChange.value = details.isDetailsUpdated;
  detailsChanged.value = details.detailChanged;
  if (details.updatedDetails) {
    updatedDetails.value = details.updatedDetails;
  }
  setTimeout(() => {
    successfulDetailChange.value = false;
  }, 3000);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (!successfulDetailChange.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(EditableUserDetails, {
              editableDetails: editableDetails.value,
              onToggleSuccessMessage: toggleSuccessMessage
            }, null, 8, ["editableDetails"]),
            (!isChangingPassword.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("button", {
                    class: "btn btn-default",
                    onClick: toggleChangePassword,
                    "data-test": "change-password"
                  }, " Change password ")
                ]))
              : (_openBlock(), _createBlock(ChangePassword, {
                  key: 1,
                  onToggleChangePassword: toggleChangePassword,
                  onToggleSuccessMessage: toggleSuccessMessage
                }))
          ]))
        : (_openBlock(), _createBlock(SuccessMessage, {
            key: 1,
            "toggle-success-message": "toggleSuccessMessage",
            actionSuccess: successfulDetailChange.value,
            detailChanged: detailsChanged.value,
            style: {"min-height":"320px"}
          }, null, 8, ["actionSuccess", "detailChanged"])),
      (_unref(csContext).user.subscriptionLevel === 'Full')
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _hoisted_7,
            _createVNode(MyProfileSettings, { userId: userId.value }, null, 8, ["userId"])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})